<template>
  <footer class="bg-gray-900" aria-labelledby="footer-heading">
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <div class="mx-auto max-w-7xl px-6 pb-8 pt-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="space-y-8">
          <nuxt-link to="https://bigleaphealth.com" target="_blank">
            <logo class="w-28" />
          </nuxt-link>

          <div class="flex space-x-6">
            <a
              v-for="item in navigation.social"
              :key="item.name"
              :href="item.href"
              class="text-gray-500 hover:text-gray-400"
            >
              <span class="sr-only">{{ item.name }}</span>
              <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <ul role="list" class="mt-6 space-y-4">
                <li v-for="item in navigation.col1" :key="item.name">
                  <a
                    :href="item.href"
                    class="text-sm leading-6 text-gray-300 hover:text-white"
                    >{{ item.name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <ul role="list" class="mt-6 space-y-4">
                <li v-for="item in navigation.col2" :key="item.name">
                  <a
                    :href="item.href"
                    class="text-sm leading-6 text-gray-300 hover:text-white"
                    >{{ item.name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
        <p class="text-xs leading-5 text-gray-400">
          &copy; {{ year }} Manhattan Restorative Health Sciences. All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import Logo from "~/assets/images/Logo.svg";
import Facebook from "~/assets/images/icons/facebook.svg";
import Instagram from "~/assets/images/icons/instagram.svg";
import X from "~/assets/images/icons/x.svg";
import YouTube from "~/assets/images/icons/youtube.svg";

const year = new Date().getFullYear();

const navigation = {
  col1: [
    { name: "About", href: "https://www.mrhsclinics.com/about" },
    { name: "Locations", href: "https://www.mrhsclinics.com/locations" },
    { name: "Approach", href: "https://www.mrhsclinics.com/approach" },
    { name: "CSP Medical", href: "https://www.mrhsclinics.com/csp-medical" },
  ],
  col2: [
    { name: "Wellness", href: "https://www.mrhsclinics.com/wellness" },
    { name: "Patients", href: "https://www.mrhsclinics.com/patients" },
    { name: "Research", href: "https://www.mrhsclinics.com/research" },
    { name: "Careers", href: "https://www.mrhsclinics.com/careers" },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/CSPNY",
      icon: Facebook,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/manhattanrestorative",
      icon: Instagram,
    },
    {
      name: "X",
      href: "https://twitter.com/mrhsclinics",
      icon: X,
    },

    {
      name: "YouTube",
      href: "https://www.youtube.com/channel/UCAWWnE06grkTtLV0Hp1XIsw",
      icon: YouTube,
    },
  ],
};
</script>
